import isFunction from '../utils/is-function';

function Render({ children, if: condition }) {
  if (condition) {
    if (isFunction(children)) {
      return children();
    }

    return children;
  }

  return null;
}

export default Render;
